import type { DocumentFromResponse } from 'shared/features/documents/documents.types';

export const getImplementationDate = ({ document }: { document: DocumentFromResponse }) => {
  return document.implementation_date;
};
